import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import "./OHA.css";

import myVideo from '../../videos/ohastart.mp4';
import additionalVideo1 from '../../videos/OHAintro.mp4';
import additionalVideo2 from '../../videos/OHA4Years.mp4';

import photo1 from "../../images/oha/img (1).jpg";
import photo2 from "../../images/oha/img (2).jpg";
import photo3 from "../../images/oha/img (3).jpg";
import photo4 from "../../images/oha/img (4).jpg";
import photo5 from "../../images/oha/img (5).jpg";
import photo6 from "../../images/oha/img (6).jpg";
import photo7 from "../../images/oha/img (7).jpg";
import photo8 from "../../images/oha/img (8).jpg";
import photo9 from "../../images/oha/img (9).jpg";
import photo10 from "../../images/oha/img (10).jpg";
import photo11 from "../../images/oha/img (11).jpg";
import photo12 from "../../images/oha/img (12).jpg";
import photo13 from "../../images/oha/img (13).jpg";
import photo14 from "../../images/oha/img (14).jpg";
import photo15 from "../../images/oha/img (15).jpg";
import photo16 from "../../images/oha/img (16).jpg";
import photo17 from "../../images/oha/img (17).jpg";
import photo18 from "../../images/oha/img (18).jpg";
import photo19 from "../../images/oha/img (19).jpg";

function OHA() {
  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  const photos = [
    {
      src: photo1,
      alt: "Books, stationary and bags distribution",
      title: "Books & Supplies Distribution",
      description: "Books, stationary and bags distributions for OHA program students."
    },
    {
      src: photo2,
      alt: "OHA new classroom",
      title: "Classroom Reconstruction",
      description: "OHA new class look after reconstruction - modern learning environment."
    },
    {
      src: photo3,
      alt: "OHA renovated classroom",
      title: "Enhanced Learning Spaces",
      description: "OHA new class look after reconstruction with improved facilities."
    },
    {
      src: photo4,
      alt: "Student seminar competition",
      title: "Student Achievement Ceremony",
      description: "Student seminar competition closing program celebrating excellence."
    },
    {
      src: photo5,
      alt: "New centre opening",
      title: "New Educational Center",
      description: "Opening a new centre in Kabul to provide free education for more children."
    },
    {
      src: photo6,
      alt: "Centre expansion",
      title: "Expanding Our Reach",
      description: "New centre opening to serve more children in the community."
    },
    {
      src: photo7,
      alt: "Computer class setup",
      title: "Digital Learning Initiative",
      description: "Establishing new computer class to teach technology skills."
    },
    {
      src: photo8,
      alt: "Students in computer lab",
      title: "Technology Education",
      description: "Students learning essential computer skills in our new lab."
    },
    {
      src: photo9,
      alt: "Centre inauguration",
      title: "Community Celebration",
      description: "Grand opening of our new educational facility in Kabul."
    },
    {
      src: photo10,
      alt: "New facility",
      title: "Growing Together",
      description: "Expanding educational opportunities for children in Afghanistan."
    },
    {
      src: photo11,
      alt: "Ramadan program",
      title: "Ramadan Programs",
      description: "Commemoration of holy Quran during the blessed month of Ramadan."
    },
    {
      src: photo12,
      alt: "Students taking exams",
      title: "Monthly Assessments",
      description: "Students demonstrating their knowledge through monthly exams."
    },
    {
      src: photo13,
      alt: "Educational tour",
      title: "Learning Beyond Classroom",
      description: "Kabul Zoo exploration - educational tour for OHA students and teachers."
    },
    {
      src: photo14,
      alt: "Zoo visit",
      title: "Field Trip Experience",
      description: "Students exploring and learning about wildlife at Kabul Zoo."
    },
    {
      src: photo15,
      alt: "Founder speech",
      title: "Inspirational Guidance",
      description: "Mohammad Waris Azimi, Founder of OHA, inspiring students with motivational speech."
    },
    {
      src: photo16,
      alt: "Prize distribution",
      title: "Academic Excellence Awards",
      description: "Best essay competition closing program and prize distribution ceremony."
    },
    {
      src: photo17,
      alt: "Facility opening",
      title: "New Opportunities",
      description: "Opening doors to education for hundreds of Afghan children."
    },
    {
      src: photo18,
      alt: "Aid distribution",
      title: "Supporting Students",
      description: "With ANW support, distributing stationary and bags to 300 children."
    },
    {
      src: photo19,
      alt: "Student aid program",
      title: "Empowering Through Resources",
      description: "Ensuring every child has the tools they need to succeed in education."
    }
  ];

  const videos = [
    {
      src: myVideo,
      title: "How OHA Started?",
      description: "The inspiring story of One Hour for Afghanistan's founding"
    },
    {
      src: additionalVideo1,
      title: "ANW & OHA First Collaboration",
      description: "The beginning of a powerful partnership for education"
    },
    {
      src: additionalVideo2,
      title: "Impact of ANW on OHA",
      description: "Celebrating years of transformation and growth"
    }
  ];

  return (
    <div>
      <h1 className="oha" data-aos="fade-down">
        <span className="oha-title-text">One Hour For Afghanistan (OHA)</span>
      </h1>

      <div className="aboutoha" data-aos="fade-up">
        <h1 data-aos="fade-down" data-aos-delay="100">About OHA</h1>
        <div className="donateSection">
          <p data-aos="fade-up" data-aos-delay="200">
            Founded by the family of Mohammad Waris Azimi in April 2019, One Hour for Afghanistan (OHA)
            is a volunteer-driven NGO dedicated to providing free education for children in Afghanistan.
            Managed by Homayoun Ebrahim Khail, OHA serves both boys and girls and recently established
            a sewing class for women to help them become self-sufficient. With monthly expenses around
            $400, our initiative began with a passionate group of young volunteers who sought to
            make a positive impact in the lives of Afghan children through education. Since our inception,
            we have been committed to empowering the next generation by offering educational programs that
            foster learning and growth, all at no cost to the families we serve.
          </p>
        </div>
      </div>

      <hr />
      
      <div className="video-section" data-aos="fade-up">
        <div className="video-container">
          {videos.map((video, index) => (
            <div key={index} data-aos="zoom-in" data-aos-delay={100 + (index * 100)}>
              <h2 className="video-title">{video.title}</h2>
              <video controls>
                <source src={video.src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
      </div>

      <hr />

      <div className="carousel-section" data-aos="fade-up">
        <h2 className="carousel-title" data-aos="fade-down" data-aos-delay="100">
          Our Photo Gallery
        </h2>
        <div data-aos="zoom-in" data-aos-delay="200">
          <Carousel 
            showArrows={true} 
            showThumbs={false} 
            infiniteLoop={true} 
            autoPlay={true} 
            interval={4000} 
            transitionTime={800} 
            showStatus={false}
          >
            {photos.map((photo, index) => (
              <div className="photo-section" key={index}>
                <h2 className="photo-title">{photo.title}</h2>
                <p className="photo-text">{photo.description}</p>
                <img src={photo.src} alt={photo.alt} className="photo" />
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      <hr />
      
      <div className="whatWeDo" data-aos="fade-up">
        <h1 data-aos="fade-down" data-aos-delay="100">Our Mission & Programs</h1>
        <p data-aos="fade-up" data-aos-delay="200">
          <strong>Our Mission:</strong> Empowering Through Education<br/><br/>
          At One Hour for Afghanistan, our mission is to create educational opportunities for children in Afghanistan who might otherwise be deprived of learning. We provide:<br/><br/>
          <strong>• Free Educational Programs:</strong> Offering a wide range of subjects, from basic literacy and numeracy to more advanced topics.<br/><br/>
          <strong>• Volunteer-Led Classes:</strong> Conducted by dedicated volunteers who are passionate about teaching and making a difference.<br/><br/>
          <strong>• Community Engagement:</strong> Encouraging community involvement and support to create a sustainable educational environment.<br/><br/>
          <strong>• Support and Resources:</strong> Providing necessary educational materials and resources to ensure effective learning experiences.<br/><br/>
          <strong>• Women's Empowerment:</strong> Sewing classes for women to develop skills and achieve economic independence.<br/><br/>
          Our efforts aim to nurture the potential of every child, helping them to build a brighter future through the power of education.
        </p>
      </div>
    </div>
  );
}

export default OHA;